import { post, put, del } from './requests'

const resourcePath = 'trackings'

export function createDocumentTracking ({ documentId, ...restData }) {
  return post(`documents/${documentId}/${resourcePath}`, { tracking: restData })
}

export function updateDocumentTracking ({ documentId, id, ...restData }) {
  return put(`documents/${documentId}/${resourcePath}/${id}`, {
    tracking: restData
  })
}

export function deleteDocumentTracking ({ documentId, id }) {
  return del(`documents/${documentId}/${resourcePath}/${id}`)
}
